import {ref} from 'vue';

export default {
    install: (app, options) => {
        const files = ref([]);

        const loadProjectFiles = (url) => {
            window.lazy_axios.get(url)
                .then((response) => {
                    files.value = response.data.files.data;
                });
        };

        app.provide('projectFiles', files);
        app.provide('loadProjectFiles', loadProjectFiles);
    },
}
